import { TextField } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setEncryptedPrivateKey } from "../../../store/reducers/keys";
import { useWeb3Auth } from "../../../hooks/useWeb3Auth";
import "./index.css";
import { getSecrets } from "../../../config";
const KeyTransfer = () => {
  const { AUTH_SERVER_URL } = getSecrets();
  const { t } = useTranslation();
  const [keyInput, setKeyInput] = useState("");
  const dispatch = useDispatch();
  const { address } = useWeb3Auth();
  const onSubmit = () => {
    if (!address || !keyInput) return;
    dispatch(
      setEncryptedPrivateKey({
        encryptedPrivateKey: keyInput,
        currentAddress: address,
      })
    );
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (keyInput) {
        onSubmit();
      }
    }
  };
  return (
    <div data-testid="key-transfer-indicator">
      <p className="keytransfer__open-window-desc">
        {t("Mnemonic_Enable_1on1_Features")}
      </p>
      <button
        onClick={() => {
          window.open(AUTH_SERVER_URL, "newwindow", "width=350,height=700");
        }}
        className="keytransfer__open-window-button"
      >
        {t("Mnemonic_Get_Token")}
      </button>
      <div className="keytransfer__input-container">
        <TextField
          id="pin"
          //   error={!!pinError}
          //   helperText={pinError}
          label={t("Mnemonic_Enter_Token")}
          InputLabelProps={{
            style: { 
              fontSize: "14px"
            },
          }}
          variant="standard"
          margin="dense"
          value={keyInput}
          onChange={(e) => {
            setKeyInput(e.target.value);
          }}
          type="password"
          onKeyDown={handleKeyDown}
        />
        <button className="keytransfer__continue-button" onClick={onSubmit}>
        {t("Mnemonic_Confirm_Token")}
        </button>
      </div>
    </div>
  );
};
export default KeyTransfer;
